import axios from "axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { PushApplicationState, PushApplicationFilterParams, PushApplicationItem } from './types';


export const actions: ActionTree<PushApplicationState, RootState> = {
  async getPushApplications({commit}, filter: PushApplicationFilterParams) {
    try {
      const resp = await axios({
        url: "/lk-api/distribution/push/application",
        params: filter,
      });
      commit("setPushApplications", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushOS({commit}) {
    try {
      const resp = await axios({url: "/lk-api/push/os"});
      const data = resp.data.map((i:any) => i.os);
      commit("setPushOS", data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushOSVersions({commit}, filter: any) {
    try {
      const resp = await axios({
        url: "/lk-api/push/os/versions",
        params: filter
      });
      commit("setPushOSVersions", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushSDKVersions({commit}, filter: any) {
    try {
      const resp = await axios({
        url: "/lk-api/push/sdk/versions",
        params: filter
      });
      commit("setPushSDKVersions", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushMappVersions({commit}, filter: any) {
    try {
      const resp = await axios({
        url: "/lk-api/push/mapps/versions",
        params: filter
      });
      commit("setPushMappVersions", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushFilters({commit}) {
    try {
      const resp = await axios({url: "/lk-api/distribution/push/filter"});
      commit("setPushFilters", resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async savePushFilter({commit, dispatch}, item: any) {
    try {
      const resp = await axios({
        method: 'post',
        url: '/lk-api/distribution/push/filter',
        data: item,
      })
      // dispatch('getPushFilters');
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getPushGroupApplications({commit}) {
    try {
      const resp = await axios({
        url: "/lk-api/distribution/push/applications/groups"
      });
      commit("setPushGroupApplications", resp.data.groups);
      return resp;
    } catch (err) {
      throw err;
    }
  }
}
